import { useMemo } from "react";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonBadge from "components/ArgonBadge";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";

const columns2 = [
  { name: "sno", align: "center" },
  { name: "Address", align: "left" },
  { name: "lat", align: "center" },
  { name: "lng", align: "center" },
  { name: "radius", align: "center" },
  // { name: "action", align: "center" },
];

const LocationPreferenceTableData = (tutor) => {
  const rows2 = useMemo(() => {
    if (!tutor) return [];

    const locations = tutor.locationPreference || [];

    return locations.map((loc, index) => {
      // Use individual location's address if available, otherwise fall back to tutor's address
      const fullAddress = loc.address || "N/A";

      return {
        sno: (
          <ArgonTypography variant="caption" color="text" fontWeight="medium">
            {index + 1}
          </ArgonTypography>
        ),
        Address: (
          <ArgonTypography variant="caption" color="text" fontWeight="medium">
            {fullAddress}
          </ArgonTypography>
        ),
        lat: (
          <ArgonTypography variant="caption" color="text" fontWeight="medium">
            {loc.lat ? loc.lat.toFixed(4) : "N/A"}
          </ArgonTypography>
        ),
        lng: (
          <ArgonTypography variant="caption" color="text" fontWeight="medium">
            {loc.lng ? loc.lng.toFixed(4) : "N/A"}
          </ArgonTypography>
        ),
        radius: (
          <ArgonTypography variant="caption" color="text" fontWeight="medium">
            {loc.radius || "N/A"}
          </ArgonTypography>
        ),
      };
    });
  }, [tutor]);

  return { columns2, rows2 };
};

export default LocationPreferenceTableData;
